<template>
    <base-button :disabled="disabled" class="btn--red">
        <slot></slot>
    </base-button>
</template>

<script>
import BaseButton from './base_button';
export default {
  components: {
    'base-button': BaseButton,
  },
  props: {
    disabled: {
      type: Boolean,
    },
  },
};
</script>
